import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AIS140ApiReqLogsComponent } from './ais140-api-req-logs.component';
const routes: Routes = [
  {
    path: 'ais140-api-req-logs',
    data: { name: 'AIS140 Ticket TML Request Logs', isTab: false },
    component: AIS140ApiReqLogsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AIS140ApiReqLogsRoutingModule {}
